/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Voucher } from './Voucher';
import {
    VoucherFromJSON,
    VoucherFromJSONTyped,
    VoucherToJSON,
} from './Voucher';

/**
 * 
 * @export
 * @interface VoucherBulk
 */
export interface VoucherBulk {
    /**
     * 
     * @type {Voucher}
     * @memberof VoucherBulk
     */
    voucher?: Voucher;
    /**
     * 
     * @type {number}
     * @memberof VoucherBulk
     */
    amount: number;
}

/**
 * Check if a given object implements the VoucherBulk interface.
 */
export function instanceOfVoucherBulk(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "amount" in value;

    return isInstance;
}

export function VoucherBulkFromJSON(json: any): VoucherBulk {
    return VoucherBulkFromJSONTyped(json, false);
}

export function VoucherBulkFromJSONTyped(json: any, ignoreDiscriminator: boolean): VoucherBulk {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'voucher': !exists(json, 'voucher') ? undefined : VoucherFromJSON(json['voucher']),
        'amount': json['amount'],
    };
}

export function VoucherBulkToJSON(value?: VoucherBulk | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'voucher': VoucherToJSON(value.voucher),
        'amount': value.amount,
    };
}

